import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../../../../shared/types/analytics';

interface ITrackPaymentSuccessParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  amount: number;
}

export const trackPaymentSuccess = (params: ITrackPaymentSuccessParams) => {
  const { analyticsOfferStatus, amount } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'success_pay',
    label: amount,
  });
};

export const trackPaymentCanceled = (analyticsOfferStatus: TAnalyticsOfferStatus) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'recharge_balance_popup',
    label: 'status_error',
  });
};

export const trackPaymentTimeout = (analyticsOfferStatus: TAnalyticsOfferStatus) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'recharge_balance_popup',
    label: 'timeout',
  });
};

interface ITrackRetryPaymentClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  amount: number;
}

export const trackRetryPaymentClick = (params: ITrackRetryPaymentClickParams) => {
  const { analyticsOfferStatus, amount } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'retry_to_pay',
    label: amount,
  });
};
